import { SignUp } from "@clerk/clerk-react";
import { createFileRoute, useLinkProps } from "@tanstack/react-router";
import { StartPageShell } from "~/components/app-shell/start-page-shell";
import { Route as OnboardingRoute } from "~/routes/onboarding/route";
export const Route = createFileRoute("/(auth)/sign-up")({
  component: SignUpPage,
  head: () => ({
    meta: [{ title: "Sign Up" }],
  }),
});

function SignUpPage() {
  const { href: redirectUrl } = useLinkProps({
    to: OnboardingRoute.fullPath,
    search: { source: "sign-up" },
  });

  return (
    <StartPageShell>
      <StartPageShell.MainContent>
        <SignUp
          fallbackRedirectUrl={redirectUrl}
          forceRedirectUrl={redirectUrl}
        />
      </StartPageShell.MainContent>
    </StartPageShell>
  );
}
